import { initGlobalState,MicroAppStateActions } from "qiankun";

const initialState = {}
const actions = initGlobalState(initialState)

export default actions